import './src/js/setPublicPath';
import { GamedayAppBase } from '@gameday/app';
import initClient from 'bdata-react-component';
import { DataEngine } from '@gameday/core';
import componentMap from './src/componentMap';
import siteConfig from './src/js/site-config-options';
import initAdobeTarget from '@gameday/utils/getAdobeTarget';
import changeConfigAction from '@gameday/app/lib/store/actions/config';
import './lib/styles/app.css';

class GamedayApp extends GamedayAppBase {
    constructor (opts) {
        super(opts);

        const moreOpts = {
            componentMap,
            DataEngine
        };

        const _root = initClient(this.appContainer, { ...this.opts, ...moreOpts });
        this.init(_root);
    }
}

export const bootstrap = function () {
    const app = new GamedayApp({ ...siteConfig.game, config: siteConfig.config, mount: siteConfig.mount, tracking: siteConfig.tracking, ads: siteConfig.ads });
    app.prefetch().then(() => {
        app.render();
    }).then(() => {
        initAdobeTarget().then((mbox) => {
            app.store.dispatch(changeConfigAction({ mbox }));
        });

        if (window?.team_info) {
            app.store.dispatch(changeConfigAction({ teamInfo: window?.team_info }));
        }
    });
};

export default GamedayApp;
